<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-4 w-100">
      <h4><i class="fas fa-bars"></i> {{title | translate}} {{service}}</h4>
    </div>
  </div>
</div>
<div class="form-inline mt-2">
  <div class="col-md-9 w-100 pl-0">
    <div class="row mr-18" *ngIf="hasRole(ROLE_SUPERADMIN) && getVisibilityTagPartner()">
      <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.PARTNER" | translate }}</strong></dt>
      <div class="col-md-1 mr-lr">:</div>
      <div class="col-md-8">
        <span style="color: #ee1818" class="mr-left-0">{{ headerParameters.partnerName }} </span>
      </div>
    </div>
    <div class="row mr-18"
         *ngIf="(hasRole(ROLE_PARTNER) && getVisibilityTagEnterprise()) || (hasRole(ROLE_SUPERADMIN) && getVisibilityTagEnterprise())">
      <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.ENTERPRISE" | translate }}</strong></dt>
      <div class="col-md-1 mr-lr">:</div>
      <div class="col-md-8">
        <span style="color: #ee1818" class="mr-left-0">{{ headerParameters.enterpriseName }} </span>
      </div>
    </div>
    <div class="row mr-18">
      <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.DATE-RANGE" | translate }}</strong></dt>
      <div class="col-md-1 mr-lr">:</div>
      <div class="col-md-8"><span> {{ "LABEL.FROM" | translate }} {{ formatter.format(headerParameters.fromDate) }}
        {{ "LABEL.TO" | translate }} {{ formatter.format(headerParameters.toDate)}}</span></div>
    </div>
    <div class="row mr-18">
      <dt class="col-md-3 p-r-0"><strong>{{ "LABEL.QUANTITY" | translate }}</strong></dt>
      <div class="col-md-1 mr-lr">:</div>
      <div class="col-md-8"><span>{{ headerParameters.quantity }}</span></div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="row">
      <div class="form-inline col-md-7 custom-style justify-content-end mb-0">
        <button type="button"
                class="btn btn-danger btn-width-100"
                (click)="back()">
          <i aria-hidden="true" class="image fas fa-reply"></i>
          {{ "BUTTON.BACK" | translate }}
        </button>
      </div>
      <div class="form-inline col-md-5 custom-style btn-width-100 justify-content-end mb-0">
        <button type="button"
                class="btn btn-success dxbs-button w-100"
                (click)="downloadReportOf()">
          <i class="image far fa-file-excel"></i>
          {{ "BUTTON.EXPORT" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="table-responsive mt-2 mb-2 custom-table-height">
  <table class="table-sm table-bordered">
    <thead>
    <tr>
      <th scope="col" title="#"></th>
      <th scope="col" title="{{'TABLE.HEADER.YEAR' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.MONTH' | translate }}"></th>
      <th scope="col" title="Ruc"></th>
      <th scope="col" title="{{'TABLE.HEADER.ENTERPRISE' | translate }}" *ngIf="hasRole(ROLE_SUPERADMIN)"></th>
      <th scope="col" title="{{'TABLE.HEADER.FLOW' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.QUANTITY' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.UNIT-PRICE-IOF' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.IOF-CONSUMED' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.ACTION' | translate }}"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let iofFirstDetail of iofFirstDetails; let index=index"
        class="{{hasRole(ROLE_PARTNER)?'custom-font-size-table-body':'custom-font-size-table-body-isnt-partner'}}">
      <td title="#">{{(page.number * pageNumber) + index + 1}}</td>
      <td title="{{'TABLE.HEADER.YEAR' | translate }}">{{iofFirstDetail.year}}</td>
      <td title="{{'TABLE.HEADER.MONTH' | translate }}">{{iofFirstDetail.monthName}}</td>
      <td title="Ruc">{{iofFirstDetail.ruc}}</td>
      <td title="{{'TABLE.HEADER.ENTERPRISE' | translate }}"
          *ngIf="hasRole(ROLE_SUPERADMIN)">{{iofFirstDetail.enterpriseName}}</td>
      <td title="{{'TABLE.HEADER.FLOW' | translate }}">{{iofFirstDetail.workflowDescription}}</td>
      <td title="{{'TABLE.HEADER.QUANTITY' | translate }}">{{iofFirstDetail.quantity}}</td>
      <td title="{{'TABLE.HEADER.UNIT-PRICE-IOF' | translate }}">
        <span class="badge badge-warning" data-toggle="tooltip" data-placement="bottom"
              title="-{{iofFirstDetail.weight.toFixed(4)}}">{{iofFirstDetail.weight.toFixed(4)}}</span>
      </td>
      <td title="{{'TABLE.HEADER.IOF-CONSUMED' | translate }}">
        <span class="badge badge-danger" data-toggle="tooltip" data-placement="bottom"
              title="-{{iofFirstDetail.consumed.toFixed(4)}}">-{{iofFirstDetail.consumed.toFixed(4)}}</span>
      </td>
      <td title="{{'TABLE.HEADER.ACTION' | translate }}">
        <div class="dropdown">
          <button type="button" class="btn btn-default " id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <button class="dropdown-item poniter"
                    (click)="openDetailModal(iofFirstDetail)">
              <i class="fa fa-align-left"></i> {{ "BUTTON.SEE-DETAIL" | translate }}
            </button>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<nav class="Page navigation pagination-custom">
  <div class="row">
    <div class="col-md-8 mt-1">
      <div class="justify-content-row">
        <label class="mr-1 font-weight-normal">Mostrar </label>
        <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                (ngModelChange)="loadDetail(enumPage.First)">
          <option *ngFor="let page of pageNumbers" [value]="page.value"
                  class="font-weight-bold">{{page.value}}</option>
        </select>
        <label class="font-weight-normal"> registros.</label>
      </div>
      <div class="page-total-entries">
        {{ "LABEL.TOTAL-RECORDS" | translate }}
        : {{iofFirstDetails.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
      </div>
    </div>
    <div class="col-md-4">
      <ul class="pagination justify-content-end text-center">
        <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
          <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadDetail(enumPage.First)"
             tabindex="-1" aria-disabled="true">
            <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
            {{ "BUTTON.FIRST" | translate }}
          </a>
        </li>
        <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
          <a class="left {{page.number == 0 ? 'disabled' : ''}}"
             (click)="loadDetail(enumPage.Previous)">
            <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="right" (click)="loadDetail(enumPage.Next)"><i
            class="fa fa-angle-right" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="next" (click)="loadDetail(enumPage.Last)">
            {{ "BUTTON.LAST" | translate }}
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<app-loading *ngIf="loading"></app-loading>
